//HW/CS Progressbar Function Start

//$(document).ready(function () {

$(function () {
    $('.project').each(function () {
        var $projectBar = $(this).find('.bar');
        var $projectPercent = $(this).find('.percent');
        var $projectRange = $(this).find('.ui-slider-range');
        $projectBar.slider({
            range: "min",
            animate: true,
            value: 0,
            min: 0,
            max: 100,
            step: 1,
            slide: function (event, ui) {
                $projectPercent.val(ui.value + "%");
            },
            change: function (event, ui) {
                var $projectRange = $(this).find('.ui-slider-range');
                var percent = ui.value;
                if (percent < 30) {
                    $projectPercent.css({
                        'color': '#fe4d97'
                    });
                    $projectRange.css({
                        'background': '#fe4d97'
                    });
                } else if (percent > 31 && percent < 50) {
                    $projectPercent.css({
                        'color': '#f8e71c'
                    });
                    $projectRange.css({
                        'background': '#f8e71c'
                    });
                } else if (percent > 50) {
                    $projectPercent.css({
                        'color': '#6dd230'
                    });
                    $projectRange.css({
                        'background': '#6dd230'
                    });
                }
            }
        });
    })
})
//});

//HS/CS Page Progress Bar End

// $('.sidenav a').hover(function () {
//     $(".sidenav").css({
//         "width": "250px"
//     });
//     $(".header_main").css({
//         "padding-left": "250px"
//     });
//     $(".dashboardmain").css({
//         "padding-left": "250px"
//     });
//     $(".sidenav a span").css({
//         "width": "110px"
//     });
//     $(".sidenav .logo img.showimg").css({
//         "display": "block",
//         "margin-left": "65px"
//     });
//     $(".sidenav .logo img.hideimg").css({
//         "display": "none"
//     });
// }, function () {
//     $(".sidenav").css({
//         "width": "76px"
//     });
//     $(".header_main").css({
//         "padding-left": "76px"
//     });
//     $(".dashboardmain").css({
//         "padding-left": "76px"
//     });
//     $(".sidenav a span").css({
//         "width": "0px"
//     });
//     $(".sidenav .logo img.showimg").css({
//         "display": "none"
//     });
//     $(".sidenav .logo img.hideimg").css({
//         "display": "block",
//         "margin-left": "21px"
//     });
// })


//Analytics page Menu Start

$(document).ready(function () {
    // $('.alls').hide();
    // $('.alls1').show();
    // $('.clickh').click(function () {
    //     var type = $(this).data('type');
    //     $('.alls').hide();
    //     $('.alls' + type).fadeIn();
    //     $('.clickh').removeClass('active');
    //     $(this).addClass('active');
    // });
});

//Analytics page Menu End

//custom tabs

$('.tabs_l ul li').click(function () {
    $('.tabs_l ul li').removeClass('active');
    $(this).addClass('active');

})

//custom tabs end






// $('body,html').click(function(e){
//    if($(window).width() >= 768) {
//     $('.taskNewBox').css({"width":"100%"})
//         $('.form_sdbox').css({"right":"-100%"});
//         $('.taskNewList td').removeClass('dec_width');
//     }
// });
// $('.taskNewBox').click(function(e){
//     e.stopPropagation();
// });


$('.typeA').hide();
$('.typesa').show();
$('.clickme').click(function () {
    var type = $(this).data('type');
    $('.typeA').fadeOut();
    $('.types' + type).fadeIn();
    $('.clickme').removeClass('active');
    $(this).addClass('active');

});

$('.notficationopen').click(function () {
    $('.notification_panel').slideToggle();
});

$(window).scroll(function () {
    if ($(window).scrollTop() >= 45) {
        $('.header').addClass('fixed_header');
    } else {
        $('.header').removeClass('fixed_header');
    }
});
var forEach = function (t, o, r) {
    if ("[object Object]" === Object.prototype.toString.call(t))
        for (var c in t)
            Object.prototype.hasOwnProperty.call(t, c) && o.call(r, t[c], c, t);
    else
        for (var e = 0, l = t.length; l > e; e++)
            o.call(r, t[e], e, t)
};

var hamburgers = document.querySelectorAll(".hamburger");
if (hamburgers.length > 0) {
    forEach(hamburgers, function (hamburger) {
        hamburger.addEventListener("click", function () {
            this.classList.toggle("is-active");
        }, false);
    });
}

$('.hamburger').click(function () {
    if ($(this).hasClass('is-active')) {
        $('#mySidenav2').css('left', '0px');
    } else {
        $('#mySidenav2').css('left', '-180px');
    }
});


$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 2000, function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });

$(document).ready(function () {
    $('.digitbox input').keyup(function () {
        if ($(this).val().length == $(this).attr("maxlength")) {
            $(this).parent('.form-group').next('.form-group').children('input').focus();
        }
    });
});

$(function () {
    $('input[name="daterange"]').daterangepicker({
        opens: 'left',
        showDropdowns: true,
        minYear: 1901,
        maxYear: parseInt(moment().format('YYYY'), 10)
    });
});
$('input[name="daterange"]').on('apply.daterangepicker', function (ev, picker) {
    $(this).val(picker.startDate.format('DD-MMMM') + ' - ' + picker.endDate.format('DD-MMMM'));
});

$('.TL_inner tr').click(function () {
    var elmTxt = $(this).children('td').find('span').attr("class");
    if (elmTxt == 'dispute') {
        window.open('dispute.html', '_self');
    }
});

$('.TL_inner tr').click(function () {
    var elmTxt = $(this).children('td').find('span').attr("class");
    if (elmTxt == 'Verification') {
        window.open('verification.html', '_self');
    }
});

//Task Page redirect to inner pages Strt

$(document).ready(function () {
    // $('.taskBox tr').click(function () {
    //     var elmTxt = $(this).children('td').find('span').attr("class");
    //     if (elmTxt == 'dispute') {
    //         window.open('dispute.html', '_self');
    //     }
    // });
});

$(document).ready(function () {
    // $('.taskBox tr').click(function () {
    //     var elmTxt = $(this).children('td').find('span').attr("class");
    //     if (elmTxt == 'Verification') {
    //         window.open('verification.html', '_self');
    //     }
    // });
});

//Task Page redirect to inner pages End

//Dispute page directed to chat page Start

$(document).ready(function () {
    $('.dispPage tr').click(function () {
        var elmTxt = $(this).children('td').find('span').attr("class");
        if (elmTxt == 'dispute') {
            window.open('disputes_detail.html', '_self');
        }
    });
});

//Dispute page directed to chat page End

//Back Button Redirect to user detail page
$(document).on('click', '#backButn', function (evt) {
    evt.preventDefault();
    var url = $(this).data('url');
    window.location.href = url;
});

//Back Button Redirect to user detail page


$(".movesA").hide();
$(".movesa").show();
$(".chart span").click(function () {
    var type = $(this).data("type");
    $(".movesA").hide();
    $(".moves" + type).fadeIn();
    $(".chart span").removeClass("active");
    $(this).addClass("active");
});

$('.tooltip1').click(function () {
    //    $('.tooltip1').find('.tooltiptext').css("visibility","hidden");
    $(this).find('.tooltiptext').css("visibility", "visible");

});

// $('.taskNewList tr').click(function () {
//     $('.taskNewList tr').removeClass('active');
//     $(this).addClass('active')

// });

$('.upload_outer').click(function () {
    $('.upload_outer').removeClass('active');
    $(this).addClass('active');
});

$('.upload_outer').click(function () {
    $('.check_list input').prop("checked", false);
});


$('.tooltip1').hover(function () {
    $('.tooltip1').find('.tooltiptext').css("visibility", "hidden");
    $(this).find('.tooltiptext').css("visibility", "visible");
});



//User Detail

// $(document).ready(function () {
//     $('.usrDetail').click(function () {
//         if ($(this).hasClass('is-active')) {
//             $('.UserDetail').css('right', '0px');
//         } else {
//             $('.UserDetail').css('right', '0px');
//         }
//     });
// });


// $(document).ready(function () {
//     $('.dtlClose').click(function () {
//         if ($(this).hasClass('is-active')) {
//             $('.UserDetail').css('right', '-524px');
//         } else {
//             $('.UserDetail').css('right', '-524px');
//         }
//     });
// });

//User Detail End


//Verification Code Modal

$(document).ready(function () {

    $(function () {
        'use strict';

        var body = $('.verifycont');

        function goToNextInput(e) {
            var key = e.which,
                t = $(e.target),
                sib = t.next('input');

            if (key != 9 && (key < 48 || key > 57) && (key < 96 || key > 105)) {
                e.preventDefault();
                return false;
            }

            if (key === 9) {
                return true;
            }

            if (!sib || !sib.length) {
                sib = body.find('input').eq(0);
            }
            sib.select().focus();
        }

        function onKeyDown(e) {
            var key = e.which;

            if (key === 9 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
                return true;
            }

            e.preventDefault();
            return false;
        }

        function onFocus(e) {
            $(e.target).select();
        }

        body.on('keyup', 'input', goToNextInput);
        body.on('keydown', 'input', onKeyDown);
        body.on('click', 'input', onFocus);

    })

});

//Verification Code Modal End

//
$(document).ready(function () {
    $('.all').hide();
    $('.all1').show();
    $('.clickhere').click(function () {
        var type = $(this).data('type');
        $('.all').hide();
        $('.all' + type).fadeIn();
        $('.clickhere').removeClass('active');
        $(this).addClass('active');
    });
});


//chat msg

$(document).ready(function () {
    $('.fullmsg').hide();
    $('.clickmsg').click(function () {
        var type = $(this).data('type');
        $('.fullmsg').hide();
        $('.chatdash, .radiobox, .chatBox_Btn ').hide();
        $('.fullmsg' + type).fadeIn();
        $('.clickmsg').removeClass('active');
        $(this).addClass('active');
    });
    $('.msgclose').click(function () {
        $('.fullmsg').hide();
        $('.chatdash, .radiobox, .chatBox_Btn ').show();
    });
});


//Selectbox Function

//$('.select_bx').click(function () {
//    $('.select_bx').find('ul.select_bx_cnt').slideUp();
//    $(this).find('ul.select_bx_cnt').slideToggle();
//});
//
//
//$('.select_bx_cnt li').click(function () {
//    var elmTxt = $(this).text();
//    $(this).parent('ul').prev('button').find('span').text(elmTxt);
//});

//Selectbox Function End


// $('.taskNewList tr').click(function (e) {
//     if ($(window).width() >= 768) {
//         $('.taskNewBox').css({
//             "width": "50%"
//         });
//         $('.form_sdbox').css({
//             "right": "0%"
//         });
//         $('.taskNewList td').addClass('dec_width');
//     }
// });

/*----------*/


$(document).ready(function () {
    $('.dots_btn').click(function () {
        $('.dropBox ul').slideToggle();
    });

    $('.dropBox ul li a').click(function () {
        $('.dropBox ul').slideUp();
    });
});

$(document).ready(function () {

    //piechart

    // Create the donut pie chart and insert it onto the page

    // nv.addGraph(function () {
    //     var donutChart = nv.models.pieChart()
    //         .x(function (d) {
    //             return d.label
    //         })
    //         .y(function (d) {
    //             return d.value
    //         })
    //         .showLabels(true)
    //         .showLegend(false)
    //         .labelThreshold(.05)
    //         .labelType("key")
    //         .color(["#d28715", "#ba7710", "#20cafe", "#ffab2b"])
    //         .tooltipContent(function (data) {
    //             return '<p>' + data.x + '</p>';
    //         }) // This is for when I turn on tooltips
    //         .tooltips(true)
    //         .donut(true)
    //         // .donutRatio(0.35);
    //         .donutRatio(0.45);

    //     // Insert text into the center of the donut
    //     function centerText() {
    //         return function () {
    //             var svg = d3.select("svg");

    //             var donut = svg.selectAll("g.nv-slice").filter(
    //                 function (d, i) {
    //                     return i == 0;
    //                 }
    //             );

    //             // Insert first line of text into middle of donut pie chart
    //             donut.insert("text", "g")
    //                 .text("Line One")
    //                 .attr("class", "middle")
    //                 .attr("text-anchor", "middle")
    //                 .attr("dy", "-.55em")
    //                 .style("fill", "#000");
    //             // Insert second line of text into middle of donut pie chart
    //             donut.insert("text", "g")
    //                 .text("Line Two")
    //                 .attr("class", "middle")
    //                 .attr("text-anchor", "middle")
    //                 .attr("dy", ".85em")
    //                 .style("fill", "#000");
    //         }
    //     }

    //     // Put the donut pie chart together
    //     d3.select("#donut-chart svg")
    //         .datum(seedData())
    //         .transition().duration(300)
    //         .call(donutChart)
    //         .call(centerText());
    //     //        .call(pieSlice());

    //     return donutChart;
    // });


    // Seed data to populate donut pie chart
    //     function seedData() {
    //         return [
    //             {
    //                 "label": "60%",
    //                 "value": 60
    //     },
    //             {
    //                 "label": "4%",
    //                 "value": 8
    //     },
    //             {
    //                 "label": "16%",
    //                 "value": 16
    //     },
    //             {
    //                 "label": "20%",
    //                 "value": 20
    //     }
    //   ];
    //     }


});


/*------------------*/


// User Page Pagination Start

$(document).ready(function () {

    // var items = $(".userPages .usrDetail");
    // var numItems = items.length;
    // var perPage = 8;

    // items.slice(perPage).hide();

    // $('#pagination-containers').pagination({
    //     items: numItems,
    //     itemsOnPage: perPage,
    //     prevText: "&lt;" + "&#160;" + "&#160;" + "Prev",
    //     nextText: "Next" + "&#160;" + "&#160;" + "&gt;",
    //     onPageClick: function (pageNumber) {
    //         var showFrom = perPage * (pageNumber - 1);
    //         var showTo = showFrom + perPage;
    //         items.hide().slice(showFrom, showTo).show();
    //     }
    // });


});

// User Page Pagination End

// Docs Pagination Start

$(document).ready(function () {
    // var items = $(".docsImage .docsDtl");
    // var numItems = items.length;
    // var perPage = 1;

    // items.slice(perPage).hide();

    // $('#pagination-container').pagination({
    //     items: numItems,
    //     itemsOnPage: perPage,
    //     prevText: "&lt;",
    //     nextText: "&gt;",
    //     onPageClick: function (pageNumber) {
    //         var showFrom = perPage * (pageNumber - 1);
    //         var showTo = showFrom + perPage;
    //         items.hide().slice(showFrom, showTo).show();
    //     }
    // });
});

// Docs Pagination End



$(document).ready(function () {
    function padToTwo(number) {
        if (number <= 9999) {
            number = ("0" + number).slice(-2);
        }
        return number;
    }

    (function ($) {
        $.fn.monthly = function (options) {
            var months = options.months || [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
                Monthly = function (el) {
                    this._el = $(el);
                    this._init();
                    this._render();
                    this._renderYears();
                    this._renderMonths();
                    this._bind();
                };

            Monthly.prototype = {
                _init: function () {
                    this._el.html(months[0] + " " + options.years[0]);
                },

                _render: function () {
                    var linkPosition = this._el.offset(),
                        cssOptions = {
                            display: "none",
                            position: "absolute",
                            top: linkPosition.top + this._el.height() + (options.topOffset || 0),
                            left: linkPosition.right
                        };
                    this._container = $('<div class="monthly-wrp">')
                        .css(cssOptions)
                        .appendTo($("body"));
                },

                _bind: function () {
                    var self = this;
                    this._el.on("click", $.proxy(this._show, this));
                    $(document).on("click", $.proxy(this._hide, this));
                    this._yearsSelect.on("click", function (e) {
                        e.stopPropagation();
                    });
                    this._container.on("click", "button", $.proxy(this._selectMonth, this));
                },

                _show: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    this._container.css("display", "inline-block");
                },

                _hide: function () {
                    this._container.css("display", "none");
                },

                _selectMonth: function (e) {
                    var monthIndex = $(e.target).data("value"),
                        month = months[monthIndex],
                        year = this._yearsSelect.val();
                    this._el.html(month + " " + year);
                    if (options.onMonthSelect) {
                        options.onMonthSelect(monthIndex, month, year);
                    }
                },

                _renderYears: function () {
                    var markup = $.map(options.years, function (year) {
                        return "<option>" + year + "</option>";
                    });
                    var yearsWrap = $('<div class="years">').appendTo(this._container);
                    this._yearsSelect = $("<select>")
                        .html(markup.join(""))
                        .appendTo(yearsWrap);
                },

                _renderMonths: function () {
                    var markup = ["<table>", "<tr>"];
                    $.each(months, function (i, month) {
                        if (i > 0 && i % 4 === 0) {
                            markup.push("</tr>");
                            markup.push("<tr>");
                        }
                        markup.push(
                            '<td><button data-value="' + i + '">' + month + "</button></td>"
                        );
                    });
                    markup.push("</tr>");
                    markup.push("</table>");
                    this._container.append(markup.join(""));
                }
            };

            return this.each(function () {
                return new Monthly(this);
            });
        };
    })(jQuery);


    //Wallet Page Callendar Start    

    $(document).ready(function () {
        $(function () {
            $("#selection").monthly({
                years: [2018, 2019, 2020],
                topOffset: 28,
                onMonthSelect: function (mi, m, y) {
                    mi = padToTwo(mi);
                    $("#selection").val(m + " " + y);
                }
            });
        });
    });
});

//Wallet Page Callendar End

/*-----1-8-19----*/
$('.check_list input').click(function () {
    var inpelm = $('.check_list input').is(':checked');
    if (inpelm && $('.check_list input:checked').length == 4) {
        $('.accept_btn').attr('disabled', false);
        $('.accept_btn').addClass('hvr-sweep-to-right3');
    } else {
        $('.accept_btn').attr('disabled', true);
        $('.accept_btn').removeClass('hvr-sweep-to-right3');
    }
});

$(window).on('load', function () {
    var btnElm = $('.accept_btn').attr('disabled', true);
    if (btnElm) {
        $('.accept_btn').removeClass('hvr-sweep-to-right3');
    } else {
        $('.accept_btn').addClass('hvr-sweep-to-right3');
    }
});

$('.cantcfrm input').click(function () {
    if ($('.cantcfrm input:checked').length == 2) {
        $('.blockTrade button').attr('disabled', false);
    } else {
        $('.blockTrade button').attr('disabled', true);
    }
    $('.rlsFunds button').attr('disabled', true);
});

$('.radiobutton2 input').click(function () {
    $('.blockTrade button').attr('disabled', true);
    if ($('.radiobutton2 input:checked').length == 2) {
        $('.rlsFunds button').attr('disabled', false);
    } else {
        $('.rlsFunds button').attr('disabled', true);
    }
});
